export const imageContainer = {
  mx: "30px",
  padding: "30px 0 40px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderBottom: "solid 1px",
  borderColor: "grey9",
};

export const contentContainer = {
  padding: "20px 30px 30px",
};

export const modalImage = {
  width: "100%",
  maxWidth: "400px",
};
